import axios from 'axios'

import toolApi from './toolApi'
import serviceApi from './serviceApi'
import loginApi from './loginApi'
import vipApi from './vipApi'
import homeApi from './homeApi'
import industryApi from './industryApi'

// axios.defaults.baseURL = 'http://120.78.145.43:8080/'
// axios.defaults.baseURL = '/'

axios.interceptors.request.use(
  (config) => {
    return config
  }
)

axios.interceptors.response.use(
  (response) => {
    return response.data
  }
)

export {
  toolApi,
  loginApi,
  vipApi,
  industryApi,
  homeApi,
  serviceApi
}



// WEBPACK FOOTER //
// ./src/api/index.js